import React, { Component } from 'react'
import Footer from '../footer/footer'
import data from '../../mock/schedule-mock.json'
import Schedule from '../schedule/scheduleContent'

export default class SchedulePage extends Component {
  constructor () {
    super()

    this.state = {
      data: []
    }
  }

  componentWillMount () {
    this.setState({
      data: data
    })
  }

  render() {
    const data = this.state.data.scheduleAll

    return (
      <div className="fullHeight">
        <section id="schedule-page" className="clear relative">
          <div className='squad'>
            <header>
              <div className="container squad">
                <h2 className='h2-custom'>Calendário</h2>
              </div>
            </header>

            <Schedule scheduleAll={data} propsHistory={this.props.history}/>
          </div>
        </section>
        <Footer />
      </div>
    )
  }

  componentDidMount () {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/schedule/schedule.js